module.exports = __webpack_public_path__ + "static/media/content.8cea87af.svg";